import React from "react";
import { getFirefoxCssFix } from "../../../components/commonfunctions/getFirefoxCssFix";

const Shimmer: React.FC = () => {
  return (
    <div className="mt-1.5 bg-white h-maintableheight rounded-lg flex flex-col">
      {/* Header shimmer */}
      <div className="px-6 py-5 border-b border-[#E5E9EB] flex justify-between items-center">
        <div>
          <div className="shimmer skeleton w-36 h-6 mb-2"></div>
          <div className="shimmer skeleton w-20 h-4"></div>
        </div>
        <div className="flex gap-[24px]">
          <div className="shimmer skeleton w-[91px] h-8"></div>
          <div className="shimmer skeleton w-[91px] h-8"></div>
          <div className="shimmer skeleton w-6 h-6 rounded-full"></div>
        </div>
      </div>

      {/* Body shimmer */}
      <div className={`grow px-6 pb-6 ${getFirefoxCssFix('scroll')} overflow-auto`}>
        {[...Array(3)].map((_, i) => (
          <div key={i} className="mt-6">
            <div className="shimmer skeleton w-32 h-5 mb-4"></div>
            <div className="mt-3.5">
              <div className="flex gap-5">
                {[...Array(3)].map((_, index) => (
                  <div key={index} className="mr-5 w-1/3">
                    <div className="shimmer skeleton w-[200px] h-4 mb-2"></div>
                    <div className="shimmer skeleton w-[100px] h-3"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}

        {/* SOP Shimmer */}
        <div className="mt-6">
          <div className="shimmer skeleton w-64 h-5 mb-4"></div>
          <div className="shimmer skeleton w-[340px] h-10 rounded-[8px]"></div>
        </div>

        {/* Privileges shimmer */}
        <div className="mt-5 sticky top-0 bg-white z-10">
          <div className="shimmer skeleton w-32 h-5 mb-4"></div>
        </div>
        <div className="mt-6">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="border-b border-outline py-2">
              <div className="shimmer skeleton w-32 h-5 mb-4"></div>
              <div className="-mx-2.5 flex flex-wrap">
                {[...Array(6)].map((_, i) => (
                  <div key={i} className="w-1/3 h-4 mb-2 px-[18px] py-2">
                    <p className="shimmer skeleton w-full h-4 mb-2 px-[18px] py-2"></p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Wallet shimmer */}
        <div className="mt-6">
          <div className="shimmer skeleton w-40 h-5 mb-2"></div>
          <div className="shimmer skeleton w-20 h-4"></div>
        </div>
      </div>
    </div>
  );
};

export default Shimmer;
